import { useEffect } from "react";

export const useClickOutside = (ref: any, handler: (e: MouseEvent | TouchEvent) => void) => {
  useEffect(() => {
    const refs = Array.isArray(ref) ? ref : [ref];
    const listener = (event: MouseEvent | TouchEvent) => {
      if (refs.some((s: any) => s.current) && !refs.some((s: any) => s.current.contains(event.target))) {
        handler(event);
      }
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
